import axios from 'axios';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Authenticationservice } from './../../services/authentication.service';
import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AngularFireStorage } from '@angular/fire/storage';
import Swal from 'sweetalert2';
import { required } from '@rxweb/reactive-form-validators';
declare var $: any; 

@Component({
  selector: 'app-askformoney',
  templateUrl: './askformoney.component.html',
  styleUrls: ['./askformoney.component.css']
})
export class AskformoneyComponent implements OnInit, OnDestroy {
  @ViewChild('moneydata', { static: false }) moneydataTable: any;

  userdata: any;
  usercode;
  askformoney: UntypedFormGroup;
  FormForwardFN: UntypedFormGroup;
  uploadPercentage$: Observable<number>;
  valuesTomodal: any[] = []; 
  isLoading = false;

  e_comment1 = new UntypedFormControl(null ,Validators.required);
  e_money_amt = new UntypedFormControl(null, Validators.required);
  e_docid = new UntypedFormControl(null, Validators.required);


  constructor(
    private auth: Authenticationservice, 
    private spinner: NgxSpinnerService, 
    private storage: AngularFireStorage) 
    {
    this.userdata = this.auth.Authention();
    this.usercode = this.userdata.supcode;
    this.askformoney = new UntypedFormGroup({
      comment: new UntypedFormControl(''),
      count: new UntypedFormControl(''),
      fmcode: new UntypedFormControl(''),
    });    
  }

  ngOnInit(): void {
    this.getfinancebyzone();
    this.goloadfarmerinzone();
  }

  // โหลดข้อมูลชาวไร่ 
  famerlist: any;
  goloadfarmerinzone() {
    this.spinner.show();
    let url = "";
    // ผจก โซน
    if (this.userdata.userlevel==14) {
      url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_fmcodeIn_cp6566?supzone=" + this.userdata.zonedata;
    }
    // ผจก ส่วน
    else if (this.userdata.userlevel==15) {
      url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_fmcodeIn_cp6566?partcode=" + this.userdata.zonedata;
    }
    axios.get(url)
      .then(res => {
        this.famerlist = res.data.recordset;
        this.spinner.hide();
      }).catch(err => { throw (err); })
    this.spinner.hide();
  }

  // ข้อมูลแปลงของชาวไร่ 1 คน
  dataonefarmer: any;
  canget: any;
  ckfarmer = false; 
  
  goloaddata() {
    let fmcode = ((<HTMLInputElement>document.getElementById("codefm")).value).slice(0, 10)
    this.LoadCreditamt(fmcode);
    if (fmcode == '' || fmcode.length != 10) { alert('ลองกรอกรหัวชาวไร่ใหม่ หรือ คลิ๊กเลือก') }
    else {
      this.spinner.show();
      let ckfamer = this.famerlist.filter((el: any) => el.fmcode_b1 === fmcode);
      console.log(ckfamer);
      if (ckfamer = [] || ckfamer.length == 0) { alert('ชาวไร่ไม่ได้อยู่ในโซน/ส่วนที่รับผิดชอบ') }
      else if (ckfamer[0].PromiseIN == 0 || ckfamer[0].approve == 'N') {
        alert("ไม่สามารถเบิกได้ค่ะ");
        this.ckfarmer = true;
        this.spinner.hide();
      }
      else if (ckfamer[0].zoneban == 'Y') {
        alert("ไม่สามารถทำรายการได้ เนื่องจากเป็นชาวไร่สำหรับฝ่ายกฎหมาย");
        this.ckfarmer = true;
        this.spinner.hide();
      }
      else {
        this.ckfarmer = false;
        this.spinner.hide();
      }
      
      let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_cp6566_basic_aw?fmcode='" + fmcode + "'";      
      axios.get(url)
        .then(res => {
          this.dataonefarmer = res.data.recordset;         
          this.spinner.hide();
        }).catch(err => { throw (err); })
      this.spinner.hide();

      let url2 = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/v_credit_limit_6566_w?fmcode_b1=%27" + fmcode + "%27";
      this.canget = null;
      axios.get(url2)
        .then(res => {
          this.canget = res.data.recordset;
          this.forwardcredit = this.canget[0].leftlimit;
          this.spinner.hide();
        }).catch(err => { console.log(err); })
    }

  }

  crdamt: any;
  LoadCreditamt(fmcode: any) {
    let url2 = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_sum_money_amt6566_w?fmcode=" + fmcode;
    this.canget = null;
    axios.get(url2)
      .then(res => {
        this.crdamt = res.data.recordset;
        this.spinner.hide();
      }).catch(err => { console.log(err); })
  }

  forwarditid;
  forwardfmcode;
  forwardintlandno;
  forwardcredit: any;
  checkcredit: any;
  snaponedata(itid) {
    let data = this.dataonefarmer.filter(el => el.itid == itid);
    let data2 = this.crdamt.filter((el: any) => el.intlandno.trim() == data[0].intlandno.trim());
    $("#plantnum").val(data[0].intlandno);
    this.forwardfmcode = data[0].fmcode;
    if (data2.length == 0 || data2 == null) {
      this.checkcredit = [{ 'cdam': parseInt(data[0].credit_amount), 'sma': 0 }];
    }
    else {
      this.checkcredit = [{ 'cdam': parseInt(data[0].credit_amount), 'sma': parseInt(data2[0].sum_money_amt) }];
    }
    this.forwarditid = data[0].itid;
    this.forwardintlandno = data[0].intlandno;
    document.getElementById("fmnamelable").innerHTML = data[0].fmname;
    // $("#fmname").val(data[0].fmname);
  }

  // บันทึกข้อมูล
  gosave() {
    let fmcode = this.forwardfmcode;
    let cmdcheck = parseInt(this.checkcredit[0].cdam) - parseInt(this.checkcredit[0].sma);
    let itid = this.forwarditid;
    let intlandno = this.forwardintlandno;
    let comemnt = this.askformoney.get("comment").value;
    let conut = this.askformoney.get("count").value;
    let over_limit = "0";
    let doc_status = "0";
    // กรณีเกินวงเงินแปลงนั้นๆ
    if (conut > cmdcheck ) { over_limit = "1"; doc_status = "2" }
    // สำหรับการขอจาก ผจก.ที่เกินวงเงิน
    // if (conut > this.checkcredit.cdam) { over_limit = "1" }
    // { alert("จำนวนเงินเกินวงเงิน กรุณาลองใหม่");}
    //  if ( conut  > cmdcheck && this.userdata.userlevel != '15') {
    //     alert("จำนวนเงินเกินวงเงิน กรุณาลองใหม่");
    //   }
    if (fmcode == null || fmcode == '') { alert("กรุณาระบุชาวไร่"); }
    else if (comemnt == null || comemnt == '') { alert("กรุณาระบุเหตุผล"); }
    else if (conut == null || conut == '') { alert("กรุณาระบุจำนวนเงิน"); }
    else {
      if (confirm("ยืนยันการบันทึกข้อมูล")) {
        let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/insert_getfactorw?supcode='" + this.userdata.supcode + "'"
          + "&factor_type=" + '1'
          + "&itid='" + itid + "'"
          + "&intlandno='" + intlandno + "'"
          + "&fmcode='" + fmcode + "'"
          + "&YearID='6566'"
          + "&money_amt=" + conut
          + "&comment1='" + comemnt + "'"
          + "&img_url='" + this.geturlcontact + "'"
          + "&over_limit='" + over_limit + "'"
          + "&doc_status='" + doc_status + "'";
        axios.post(url)
          .then(res => {
            if (res.data.rowsAffected[0] == 1) {
              alert("บันทึกข้อมูลเรียบร้อยแล้วค่ะ");
              this.askformoney.reset();
              this.geturlcontact = '';
              this.getfinancebyzone();
            }
            else { alert("!!!! บันทึกข้อมูลไม่สำเร็จ !!!!"); }
          }).catch(err => { throw (err); })
      }
      else {
        {
          alert(" !! ยกเลิกบันทึกข้อมูลเรียบร้อยแล้วค่ะ !!");
          this.askformoney.reset();
        }
      }
    }
  }

  geturlcontact: any;
  // upload fire ภาพ
  onFileUpload(files: FileList): void {
    console.log(files);
    const file = files[0]; // get single file
    const path = `brr_smartfarm/contract/photo/${this.userdata.supcode}/${file.name}`;
    const ref = this.storage.ref(path);
    const task = this.storage.upload(path, file);
    this.uploadPercentage$ = this.storage
      .upload(path, file)
      .percentageChanges();
    task
      .snapshotChanges()
      .pipe(
        finalize(() => {
          ref .getDownloadURL()
              .toPromise()
              .then((url) => {
                // const photo: Photo = { url };
                // console.log(url);
                // this.urlimg = = url;

                // this.firestore.collection('photos').doc(this.truckq).set(photo);
              });
          })
      )
      .subscribe();

    let bucket = 'brr-farmluck.appspot.com'
    let url_pubilc = 'https://storage.googleapis.com/' + bucket + '/brr_smartfarm/contract/photo/' + this.userdata.supcode + '/' + file.name;
    console.log(url_pubilc);
    this.geturlcontact = url_pubilc;
  }

  // clear ช่อง
  cleartext() {
    $("input:text").val("");
    this.geturlcontact = '';
  }


  // โหลดข้อมูลสินเชื่อ
  datafinance: any;
  mydatatable1: any;

  getfinancebyzone() {
    if (this.mydatatable1 != undefined ) { 
      this.mydatatable1.destroy();        
    }
    this.load_financebyzone();
  }

  load_financebyzone(){
    this.spinner.show();
    this.isLoading = true;
    let url = "";
    // console.log('userdata zonedata:' ,this.userdata.zonedata);
    if (this.userdata.userlevel ==15) {
      url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_getfinance6566w?partcode=%27" + this.userdata.zonedata + "%27&over_limit=1"
    }
    else {
      url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_getfinance6566w?zonePost=%27" + this.userdata.zonedata + "%27"
    }
    axios.get(url).then(res => {
        this.spinner.hide();
        this.datafinance = res.data.recordset;
        this.datafinance = this.datafinance.sort((a,b) => (a.docid > b.docid ? -1 : 1));
        setTimeout(() => {          
          this.mydatatable1 = $(this.moneydataTable.nativeElement).DataTable();
        }, 1000);        
        this.isLoading = false;
      }).catch(err => { throw (err) });
    this.spinner.hide();
  }
  ngOnDestroy() {
    this.forwarditid = null;
    this.forwardfmcode = null;
    this.forwardintlandno = null;
    this.forwardcredit = null;
    this.dataonefarmer = null;
    this.userdata = null;
    this.usercode = null;
    this.geturlcontact = null;
    this.datafinance = null;
  }

  // ส่งข้อมูลไปพิมพ์
  getfmcode(fmcode) {
    localStorage.setItem('fmcodedataforaskmoney', JSON.stringify(fmcode).toString());
  }

  // ต้องการยกเลิกรายการ
  cancledoc_id(doc_id) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_doc_status?docid=" + doc_id + "&doc_status=X";

    Swal.fire({
      title: 'ยืนยัน ยกเลิกเกี้ยว รายการนี้?',
      // text: 'You will not be able to recover this file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'OK ตกลง',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        axios.post(url)
        .then(res => {
          if(res.data.rowsAffected ==1) {
            Swal.fire('ยกเลิกรายการเกี้ยวสำเร็จ!', '', 'success')
            this.getfinancebyzone();
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'เกิดความผิดพลาดในการยกเลิกเกี้ยว!',
              footer: '<a href="">กรุณาลองใหม่อีกครั้ง หากยังพบปัญหา ให้ติดต่อ itBRD?</a>'
            })
          }
        })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'ยกเลิกการการทำรายการ',
          // 'Your imaginary file is safe :)',
          'cancle'
        )
      }
    })
  }

  // ส่งรายการให้ฝ่ายสินเชื่อ

  forwardtoFN(docid:string, money_amt:number, comment1:string, fmname:string, datepost:string){
    $("#forwardtofn").modal('show');
    let values: (string | number)[] = [docid, money_amt, comment1, fmname, datepost];
    this.valuesTomodal = values;
    // console.log('value to modal is ',this.valuesTomodal);
  };
  
  // บันทึกข้อมูลของ หัวหน้าส่วน ไปยังฝ่ายสินเชื่อ
  saveforwardtoFN(f: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_getfactor?docid=" + f.e_docid 
    +"&comment1=" + f.e_comment1 +"&money_amt=" + f.e_money_amt + "&doc_status=0";
    console.log('url: ',url);

    Swal.fire({
      title: 'ยืนยันการบันทึกข้อมูล?',
      // text: 'You will not be able to recover this file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'OK ตกลง',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        axios.post(url)
        .then(res => {
          if(res.data.rowsAffected ==1) {
            Swal.fire('Saved!', '', 'success')
            this.getfinancebyzone();
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'เกิดความผิดพลาดในการอัพเดตข้อมูล!',
              footer: '<a href="">กรุณาลองใหม่อีกครั้ง หากยังพบปัญหา ให้ติดต่อ itBRD?</a>'
            })
          }
        })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'ยกเลิกการบันทึกข้อมูล',
          // 'Your imaginary file is safe :)',
          'cancle'
        )
      }
    })
  };

  // ส่งรายการให้ฝ่ายสินเชื่อ
  forwardtoFNX(doc_id) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_doc_status?docid=" + doc_id + "&doc_status=0";

    if (confirm("ยืนยันส่งรายการไปยังฝ่ายสินเชื่อ ?") == true) {
      axios.post(url)
        .then(res => {
          if (res.data.rowsAffected[0] == 1) { alert("ส่งรายการไปยังฝ่ายสินเชื่อแล้ว"); this.getfinancebyzone(); }
          else {
            alert("!!! เกิดข้อผิดพลาดในการส่งรายการไปยังฝ่ายสินเชื่อ กรุณาลองใหม่ !!!")
          }
        }).catch(err => { throw (err); })
    } else {
      return false;
    }
  };

  CommaFormatted(event) {
    // skip for arrow keys
    if(event.which >= 37 && event.which <= 40) return;
    // format number
    if (this.valuesTomodal) {
      this.valuesTomodal[1] = this.valuesTomodal[1].replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }};

  numberCheck (args) {
      if (args.key === 'e' || args.key === '+' || args.key === '-') {
        return false;
      } else {
        return true;
  }};
    
  test() {
      Swal.fire(
        'The Internet?',
        'That thing is still around?',
        'question'
      )
  };  


}

